// extracted by mini-css-extract-plugin
export default {"cards":"MessagingCards_cards__PTSOJ"};